import { required, alpha_dash,email, confirmed, min_value, max_value,max,min, regex } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
import i18n from './i18n'

extend("required", {
  ...required,
  message: (_, values) => i18n.t('vee-required', values) 
});

extend("max", {
  ...max,
  message: (_, values) => i18n.t('vee-max', values) 
});

extend("min", {
  ...min,
  message: (_, values) => i18n.t('vee-min', values) 
});


extend("alpha_dash", {
  ...alpha_dash,
  message: (_, values) => i18n.t('vee-alpha_dash', values) 
});

extend("domain", {
  ...regex,
  message: (_, values) => i18n.t('vee-domain', values) 
});

extend("email", {
  ...email,
  message: (_, values) => i18n.t('vee-email', values) 
});

extend("confirmed", {
  ...confirmed,
  message: (_, values) => i18n.t('vee-confirmed', values) 
});

extend("min_value", {
  ...min_value,
  message: (_, values) => i18n.t('vee-min_value', values) 
});

extend("max_value", {
  ...max_value,
  message: (_, values) => i18n.t('vee-max_value', values) 
});
